import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CampaignSlider from '../components/Campaign/CampaignSlider'
import {FrameContainer, FixedWidthContainer} from '../styledComponents/layout'
import HorizontalScrollEpisodeCards from '../components/Episode/HorizontalScrollEpisodeCards';

const IndexPage = (props) =>  {
    const episodes = {};
    props.tags.forEach(tag => {
      let groupedEpisodes = [];
      tag.episodes.forEach(episode => {
        groupedEpisodes.push(props.episodes.find(obj => {
          return obj.episodeId === episode.id
        }));
      })
      episodes[tag.id] = groupedEpisodes;
    });
    const {allWebCampaign} = props.data;
    return (
      <div>
        <FixedWidthContainer>
          <CampaignSlider campaigns={allWebCampaign} />
        </FixedWidthContainer>
        <FrameContainer>
          {props.tags.map(tag => {
            if(episodes[tag.id]) {
              return (
                <div key={tag.id}>
                  <h2>{tag.name}</h2>
                  <HorizontalScrollEpisodeCards episodes={episodes} tag={tag} />
                </div>
              );
            } else {
              return (
                <div key={tag.id}>
                  <h2>{tag.name}</h2>
                </div>
              );
            }
          })}
        </FrameContainer>
      </div>
    );
}


export const query = graphql`
query indexPageQuery {
  allWebCampaign(filter:{isPublished: {eq:true}}, sort:{fields:[orderNumber], order:ASC}) {
    edges {
      node {
        id
        webCampaignId
        orderNumber
        title
        isPublished
        imageTitle
        imageUrl
        url
      }
    }
  }
}
`;
export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js